import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            读者热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            百万吃瓜群众在51吃瓜黑料网的真实声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.user}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-800">{comment.user}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
                <div className="flex items-center gap-1 text-primary-500 text-sm flex-shrink-0">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes.toLocaleString()}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}